export default "__VITE_ASSET__BKz6ljQ2__"